module.exports = __webpack_public_path__ + "ede59c1723abcf425c23e0c8f1dfb20a.svg";